<template>
  <el-dialog
    :append-to-body="false"
    width="80%"
    title="邀新详情"
    center=""
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div class="fs">
      用户：{{ curRow.nickname }} &nbsp;&nbsp;&nbsp;&nbsp; 账号：{{
        curRow.account
      }}
    </div>

    <VTable
      indexLabel="序号"
      :field="field"
      :loading="table.loading"
      :data="table.data"
      :total="table.total"
      :showOverflowTooltip="true"
      :hasPagionation="false"
    >
      <template v-slot:start_time="{ row }">
        {{ row.start_time }} 至 {{ row.end_time }}
      </template>
    </VTable>
  </el-dialog>
</template>

<script>
import { mixinTable } from "@/mixins/table.js";
import VTable from "@/components/VTable";
export default {
  name: "WealEdit",
  mixins: [mixinTable],
  components: {
    VTable,
  },
  data() {
    return {
      visible: false,
      isChange: false,
      loading: false,
      table: {
        loading: false,
        data: [],
        total: 0,
      },
      field: [
        { name: "user_name", label: "邀请用户", hidden: false },
        { name: "user_account", label: "邀新账号", hidden: false },
        { name: "create_time", label: "注册时间", hidden: false },
        { name: "days", label: "获赠天数(天)", hidden: false },
        { name: "start_time", label: "有效期", width: 300, hidden: false },
      ],
      curRow: null,
      allowance_count: 0,
      vip_count: 0,
    };
  },
  methods: {
    handleTabs() {
      this.table.params.page = 1;
      this.table.data = [];
      this.getTable();
    },
    // 获取详情
    getDetail(row) {
      this.curRow = row;
      this.getTable();
    },
    getTable() {
      let params_ = {
        id: this.curRow.id,
      };
      this.table.loading = true;
      this.$http
        .get("/admin/user/shareDetail", {
          params: params_,
        })
        .then((res) => {
          if (res.code === 1) {
            this.table.data = res.data.shares;
          } else {
            this.$message.error(res.msg);
          }
        })
        .finally(() => {
          this.table.loading = false;
        });
    },
    reset(done) {
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
    handleCommand(e, row) {
      console.log(e, row, "77");
      window.open(row.refund_img[e]);
    },
  },
};
</script>
<style scoped>
.fs {
  padding: 0 0 20px;
}
</style>
